import entitlement$1 from './v3/index.js';
import './v3/playback.js';

var entitlement = {
  v3: entitlement$1
};

export { entitlement as default };
//# sourceMappingURL=index.js.map
